
const getObjectDetail = 
    ({id, objectName, requestFunc, responseFunc, url, dispatch, getState}) => {
    let state = getState();
    if (state[objectName].id !== id) {
        dispatch(requestFunc(id));
        fetch(`${url}${id}`)
            .then(response => response.json())
            .then(data => {
                dispatch(responseFunc({
                    data: data
                }));
        })      
    } else {
        dispatch(responseFunc({
            data: state[objectName].data
        }));
    }
};

export default getObjectDetail;
